// Thin persistence adapter. Browser/Electron continue to use localStorage.
// Capacitor Android mirrors the small identity/session values into the native
// Preferences plugin so WebView storage eviction does not strand a player.
export function capacitorPreferences() {
  if (typeof window === 'undefined') return null;
  if (!window.Capacitor?.isNativePlatform?.()) return null;
  return window.Capacitor?.Plugins?.Preferences ?? null;
}

export async function hydrateNativeValues(keys) {
  const preferences = capacitorPreferences();
  if (!preferences || typeof localStorage === 'undefined') return;
  for (const key of keys) {
    try {
      const result = await preferences.get({ key });
      if (result?.value != null) localStorage.setItem(key, result.value);
    } catch {
      // The browser/localStorage copy remains a safe fallback.
    }
  }
}

export function persistValue(key, value) {
  if (typeof localStorage !== 'undefined') {
    if (value == null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  }
  const preferences = capacitorPreferences();
  if (!preferences) return;
  try {
    if (value == null) void preferences.remove({ key });
    else void preferences.set({ key, value });
  } catch {
    // Persistence failures must never interrupt gameplay/network requests.
  }
}
